import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserResponse } from '@interfaces/user';
import { ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';

@Injectable({ providedIn: 'root' })
export class MenuAccessService {
    private userInfo: UserResponse;

    constructor(private store: Store) {
        this.userInfo = this.store.selectSnapshot(state => state.UserState.user);
    }

    checkAccess(config: ButtonAccessConfig): boolean {

        const hasAccess = !!this.userInfo?.menuAccess?.includes(config.code);

        return !hasAccess; //return true = disabled, false = enabled

    }

}
